'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter('telephone', function () {
  return function (telephone) {
    // Insere des espaces entre les 5 groupes de 2 chiffres si le telephone commence bien par 10 chiffres, sinon laisse tel quel
    return telephone ? telephone.replace(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(.*)$/, "$1 $2 $3 $4 $5$6") : null;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/telephoneFilters.js
// module id = 2736
// module chunks = 13